import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DOCUMENT_SENDER_ENTITY_NAME, IEntityMeta } from '../../../interfaces/imetadata';
import { ServiceProviderService } from '../../../services/service.provider.service';

@Injectable({ providedIn: 'root' })
export class DocumentSenderService {
  constructor(private serviceProviderService: ServiceProviderService) {}

  getFields(namespace: string, token: string): Observable<IEntityMeta> {
    return this.getDocumentSenderFields(namespace, token);
  }

  private getDocumentSenderFields(namespace: string, token: string): Observable<IEntityMeta> {
    return this.serviceProviderService
      .getMetaDataService(namespace)
      .getEntityFields(token, DOCUMENT_SENDER_ENTITY_NAME, ['to-many', 'to-one'], undefined, namespace)
      .pipe(map((meta) => meta.entities[0]));
  }
}
